import { useTranslation } from "react-i18next";
import { type ProjectTypeId } from "@features/Login/types";
import { DownloadIcon } from "@components/icons";

interface IProjectDownloadIconProps extends React.SVGProps<SVGSVGElement> {
  projectTypeId?: ProjectTypeId;
}

export const ProjectDownloadIcon: React.FC<IProjectDownloadIconProps> = ({
  projectTypeId,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <div className="text-dark-grey relative">
      <DownloadIcon {...props} />
      <span className="absolute -right-[7px] -top-[6px] h-2 text-[8px] leading-[8px]">
        {t(`common.projectShortenings.${projectTypeId}`)}
      </span>
    </div>
  );
};
